export default __webpack_public_path__ + "static/media/DigitalTravelPayments.5de71aaa.pdf";